
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LogSectionInstance"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LogSectionInstance"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sectionInstanceId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"answers"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Answer"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAtVisitInstanceId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assessmentDate"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":185}};
    doc.loc.source = {"body":"#import \"./AnswerFragment.graphql\"\n\nfragment LogSectionInstance on LogSectionInstance {\n  sectionInstanceId\n  answers {\n    ...Answer\n  }\n  createdAtVisitInstanceId,\n  assessmentDate\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./AnswerFragment.graphql").definitions));


      module.exports = doc;
    
